module.exports = __webpack_public_path__ + "assets/pdf/E14-en-increasing-summer-rainfall.bc402638.pdf";